document.addEventListener("DOMContentLoaded", function () {
  const sections = {
    "Product-Features": document.querySelector(".Product-Features"),
    "Customer-Reviews": document.querySelector(".Customer-Reviews"),
    "Frequently-Asked-Questions": document.querySelector(".Frequently-Asked-Questions"),
    "Similar-Products": document.querySelector(".Similar-Products")
  };

  const tabs = document.querySelectorAll(".navigator-tab_content");

  // Tab click switching
  tabs.forEach(tab => {
    tab.addEventListener("click", function () {
      tabs.forEach(t => t.classList.remove("active"));
      this.classList.add("active");

      // Scroll to section smoothly
      const targetSection = sections[this.dataset.target];
      if (targetSection) {
        targetSection.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    });
  });

  // Intersection Observer
  let visibleSections = {};

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const sectionKey = Object.keys(sections).find(
          key => sections[key] === entry.target
        );
        if (!sectionKey) return;

        if (entry.isIntersecting) {
          visibleSections[sectionKey] = entry.intersectionRatio;
        } else {
          delete visibleSections[sectionKey];
        }
      });

      // Pick section with max visibility
      const mostVisible = Object.entries(visibleSections).sort(
        (a, b) => b[1] - a[1]
      )[0];

      if (mostVisible) {
        const activeTab = Array.from(tabs).find(
          tab => tab.dataset.target === mostVisible[0]
        );
        if (activeTab) {
          tabs.forEach(tab => tab.classList.remove("active"));
          activeTab.classList.add("active");
        }
      }
    },
    { threshold: [0.1, 0.25, 0.5, 0.75, 1] } // multiple steps for smoother detection
  );

  Object.values(sections).forEach(section => {
    if (section) observer.observe(section);
  });
});

                                                                                                                                                                                                                                                                                                                     